import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/plus-white.svg'


const _hoisted_1 = { class: "columns-modal-content" }
const _hoisted_2 = { class: "columns-section" }
const _hoisted_3 = ["onDragstart", "onDragover", "onDragenter", "onDrop"]
const _hoisted_4 = { class: "col-row" }
const _hoisted_5 = { class: "col-label" }
const _hoisted_6 = {
  key: 0,
  class: "type-badge"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "scroll-indicator"
}
const _hoisted_9 = {
  key: 0,
  class: "available-columns-section"
}
const _hoisted_10 = { class: "available-columns-list" }
const _hoisted_11 = { class: "col-label" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "custom-column-section" }
const _hoisted_14 = { class: "custom-column-add" }
const _hoisted_15 = {
  class: "dropdown-button input-dropdown",
  type: "button"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "modal-actions" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    "is-open": $props.isOpen,
    onClose: $setup.onClose,
    classes: 'customize-columns-modal',
    "show-close": $props.showClose
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "modal-title" }, "Columns", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "columns-scroll-container",
            ref: "scrollContainer",
            onScroll: $setup.handleScroll
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visibleColumns, (column) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["column-item", { dragging: $setup.draggedColumn === column.value, 'drag-over': $setup.dragOverColumn === column.value }]),
                key: column.value,
                draggable: true,
                onDragstart: ($event: any) => ($setup.handleDragStart($event, column)),
                onDragover: ($event: any) => ($setup.handleDragOver($event, column)),
                onDragenter: ($event: any) => ($setup.handleDragEnter($event, column)),
                onDragleave: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleDragLeave($event))),
                onDrop: ($event: any) => ($setup.handleDrop($event, column)),
                onDragend: $setup.handleDragEnd
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[3] || (_cache[3] = _createElementVNode("svg", {
                    class: "grip-icon",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("circle", {
                      cx: "4",
                      cy: "4",
                      r: "1",
                      fill: "currentColor"
                    }),
                    _createElementVNode("circle", {
                      cx: "4",
                      cy: "8",
                      r: "1",
                      fill: "currentColor"
                    }),
                    _createElementVNode("circle", {
                      cx: "4",
                      cy: "12",
                      r: "1",
                      fill: "currentColor"
                    }),
                    _createElementVNode("circle", {
                      cx: "8",
                      cy: "4",
                      r: "1",
                      fill: "currentColor"
                    }),
                    _createElementVNode("circle", {
                      cx: "8",
                      cy: "8",
                      r: "1",
                      fill: "currentColor"
                    }),
                    _createElementVNode("circle", {
                      cx: "8",
                      cy: "12",
                      r: "1",
                      fill: "currentColor"
                    }),
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "4",
                      r: "1",
                      fill: "currentColor"
                    }),
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "8",
                      r: "1",
                      fill: "currentColor"
                    }),
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "12",
                      r: "1",
                      fill: "currentColor"
                    })
                  ], -1)),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(column.value), 1),
                  (column.isCustom && column.customType)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(column.customType), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "remove-btn",
                    onClick: _withModifiers(($event: any) => ($setup.handleRemoveColumn(column)), ["stop"])
                  }, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("svg", {
                      width: "12",
                      height: "12",
                      viewBox: "0 0 12 12",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        d: "M9 3L3 9M3 3L9 9",
                        stroke: "currentColor",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      })
                    ], -1)
                  ]))], 8, _hoisted_7)
                ])
              ], 42, _hoisted_3))
            }), 128))
          ], 544),
          ($setup.canScrollDown)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "scroll-hint" }, [
                  _createElementVNode("svg", {
                    class: "chevron-down",
                    width: "12",
                    height: "12",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      d: "M3 4.5L6 7.5L9 4.5",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ])
                ], -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        ($setup.hiddenColumns.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "section-title" }, "Available Columns", -1)),
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hiddenColumns, (column) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "available-column-item",
                    key: column.value
                  }, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(column.value), 1),
                    _createElementVNode("button", {
                      class: "add-btn",
                      onClick: ($event: any) => ($setup.restoreColumn(column.value))
                    }, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M6 2V10M2 6H10",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))], 8, _hoisted_12)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "section-title" }, "Add Custom Column", -1)),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              class: "custom-column-input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.customColumnName) = $event)),
              placeholder: "Name"
            }, null, 512), [
              [_vModelText, $setup.customColumnName]
            ]),
            _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
              control: _withCtx(() => [
                _createElementVNode("label", _hoisted_15, _toDisplayString($setup.customColumnType), 1)
              ]),
              dropdown: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.columnTypes, (type) => {
                    return _createElementVNode("li", {
                      key: type,
                      onClick: ($event: any) => ($setup.selectColumnType(type)),
                      class: _normalizeClass({ 'dropdown__item-active': type === $setup.customColumnType })
                    }, _toDisplayString(type), 11, _hoisted_16)
                  }), 64))
                ])
              ]),
              _: 1
            }),
            _createElementVNode("button", {
              class: "add-custom-btn",
              onClick: $setup.addCustomColumn,
              disabled: !$setup.customColumnName.trim() || $props.isUpdating
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("img", { src: _imports_0 }, null, -1)
            ]))], 8, _hoisted_17)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            class: "reset-btn",
            onClick: $setup.resetColumns,
            disabled: $props.isUpdating
          }, [
            (!$props.isUpdating)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Reset"))
              : (_openBlock(), _createElementBlock("span", _hoisted_21, "Resetting..."))
          ], 8, _hoisted_19),
          _createElementVNode("button", {
            class: "done-btn",
            onClick: $setup.onDone,
            disabled: $props.isUpdating
          }, [
            (!$props.isUpdating)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Done"))
              : (_openBlock(), _createElementBlock("span", _hoisted_24, "Saving..."))
          ], 8, _hoisted_22)
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-open", "show-close"]))
}